<template>
	<div>
        <span v-if="type == 1">

        </span>
        <span v-if="type == 2">
            <el-dialog
                class="custom-custom"
                title="Documento"
                :visible.sync="activeShowDocument"
                :before-close="closeShowDocument"
                width="80%">
                <span v-if="!documentUrl"
                      slot="title" class="dialog__title" style="color: #fff;">
                    <p style="color:white">
                        Cargando documento, por favor espere...
                    </p>
                    <br>
                    <div v-loading="!documentUrl"></div>
                </span>
                <span v-if="documentUrl" slot="title" class="dialog__title" style="color: #fff;">
                    <el-row>
                        <el-col>
                            Documento
                            <div style="position: absolute;bottom: -2px;right: 104px;">
                            <el-button type="info" plain @click="downloadPdf" :disabled="transfer">
                                <i class="fas fa-cloud-download-alt"></i>&nbsp;Descargar
                            </el-button>
                            </div>
                        </el-col>
                    </el-row>
                </span>
                <div v-if="documentUrl" style="background: #494a4cd1">
                    <el-row>
                        <el-col>
                            <div style="width: 100%;height: 100vh;margin-left: auto;margin-right: auto">
                                <object v-if="documentUrl"
                                        :data="documentUrl"
                                        width="100%" height="100%">
                                    <p>
                                        Su navegador no soporta la vista de preview en línea, por favor descargue el archivo
                                        para visualizar.
                                    </p>
                                </object>
                            </div>

                        </el-col>
                    </el-row>
                </div>
            </el-dialog>
        </span>
	</div>

</template>

<script>
	import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';


	export default {

		props: {
			activeShowDocument: {
				required: true,
			},
			closeShowDocument: {
				required: true,
			},
			fileNameHash: {
				required: true,
			},
			urlPdfGenerate:{
				required: false,
			},
            type:{

            }
		},
		data() {
			return {
				documentUrl: null,
				transfer: false,
                photoUrl: null
			}
		},
		computed: {},
		methods: {
			init() {
				if (this.fileNameHash) {

					this.showLoading('Cargando documento...');

					let url = '/api/showFile/' + this.fileNameHash;
					axios.get(url, {responseType: 'blob'})
						.then(response => {
							this.hideLoading();
							let blob = new Blob([response.data], {type: response.data.type});
							this.documentUrl = URL.createObjectURL(blob);
							this.photoUrl = URL.createObjectURL(blob);
						})
						.catch(error => {

							this.$store.dispatch('notifications/error', {msg: 'No se pudo generar el PDF.'}, {root: true});

							this.hideLoading();
							this.transfer = false;
							console.log("error", error);
						});


				}
				if(this.urlPdfGenerate){
					this.showLoading('Cargando documento...');
					let url = this.urlPdfGenerate;
					axios.get(url, {responseType: 'blob'})
						.then(response => {
							this.hideLoading();
							let blob = new Blob([response.data], {type: response.data.type});
							this.documentUrl = URL.createObjectURL(blob);
							this.photoUrl = URL.createObjectURL(blob);
						})
						.catch(error => {
							this.hideLoading();
							this.$store.dispatch('notifications/error', {msg: 'No se pudo generar el PDF.'}, {root: true});
							this.transfer = false;
							console.log("error", error);
						});

				}
			},
			showLoading(message) {
                this.$store.dispatch(
                    'loading/spinner',
                    {msg: message, status: true},
                    {root: true}
                );
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },
			downloadPdf() {

				this.transfer = true;
				let url = null;
				if (this.fileNameHash) {
					url = '/api/showFile/' + this.fileNameHash;
				}
				if(this.urlPdfGenerate){
					url = this.urlPdfGenerate;
				}

                this.showLoading('Descargando documento...');

				axios.get(url, {responseType: 'blob'})
					.then(response => {
						this.transfer = false;
						let disposition = response.headers['content-disposition'];
						var filename = '';
						if (disposition && disposition.indexOf('inline') !== -1) {
							var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
							var matches = filenameRegex.exec(disposition);
							if (matches != null && matches[1]) {
								filename = matches[1].replace(/['"]/g, '');
							}
						}


						let blob = new Blob([response.data]);
						const linkUrl = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.href = linkUrl;

						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();
						this.hideLoading();
					})
					.catch(error => {


						this.hideLoading();
						this.transfer = false;
					});

			},
		},
		created() {
			this.init();
		}
	}
</script>

<style >
	.custom-custom  .el-dialog .el-dialog__body{
		padding: 0px;
	}
</style>
